import React from 'react';
import { useApp } from '../context/AppContext';
import Wordmark from './Wordmark';

// The wordmark in a nav bar, as a link home.
//
// Every site puts its logo top-left and every visitor expects it to take them
// back to the start — it is the one navigation control people try without
// being told. Wrapping it in a real <button> also gets keyboard focus and a
// screen-reader label for free, which a bare <span> in a <div> never had.
//
// This used to draw the thin-line seal. The seal read as a monogram at 30px
// and as a smudge on a phone; the wordmark says the name.

export default function BrandMark({ size = 22, className = 'brand', style }) {
  const { goTo } = useApp();
  return (
    <div className={className} style={style}>
      <button type="button" className="brandmark" aria-label="QPS Hub home" onClick={() => goTo('screen-home')}>
        <Wordmark size={size} />
      </button>
    </div>
  );
}
